import { Link } from 'react-router-dom';
import JublyLogo from '../components/JublyLogo';

export default function LogoPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="text-sm text-blue-600 hover:text-blue-800 mb-8 inline-block">&larr; Back to Jubly</Link>

        <div className="flex flex-col items-center text-center mb-10">
          <div className="rounded-3xl bg-gradient-to-b from-gray-50 to-white border border-gray-100 p-8 shadow-sm">
            <JublyLogo size={140} />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mt-8">About our logo</h1>
          <p className="text-sm text-gray-500 mt-2">The Jubilee dove — freedom, homecoming, and thriving.</p>
        </div>

        <div className="prose prose-gray max-w-none text-[16px] leading-relaxed">
          <p>
            The Jubly mark is a dove of peace rising to the right — toward freedom and the future — grounded in the biblical <strong>Jubilee</strong> (Leviticus 25), the fiftieth year when the ram's horn sounded to "proclaim liberty throughout the land," debts were forgiven, and everyone returned home to begin again. Its two wings carry the Jubilee's promise in color: the <span className="text-green-600 font-semibold">green</span> wing is growth, provision, and the prosperity of a restored land, while the <span className="text-blue-700 font-semibold">blue</span> wing is peace, trust, and liberty — joined by a thread of <span className="text-amber-500 font-semibold">gold</span> for jubilation and the light of a new dawn (the "year of the Lord's favor"). In its beak the dove holds an <strong>olive branch</strong>, the ancient sign of peace and reconciliation, so that freedom is shown flowering into flourishing. And the single long tail curling into a <strong>spiral</strong> speaks to the Jubilee's sacred rhythm — seven cycles of seven turning into the fiftieth-year release — as well as the Hebrew root of <em>yovel</em> itself, "to flow, to carry home": people and connection streaming freely back to one another. Altogether it reads as liberation, homecoming, and thriving — a bird set free, carrying peace, rising into a jubilee of its own.
        </p>

        <div className="not-prose grid sm:grid-cols-3 gap-4 mt-10">
          <div className="rounded-2xl border border-gray-100 p-5">
            <div className="w-4 h-4 rounded-full bg-green-500 mb-3"></div>
            <div className="font-semibold text-gray-900 text-sm">Green wing</div>
            <div className="text-sm text-gray-500 mt-1">Growth, provision, prosperity of a restored land.</div>
          </div>
          <div className="rounded-2xl border border-gray-100 p-5">
            <div className="w-4 h-4 rounded-full bg-blue-700 mb-3"></div>
            <div className="font-semibold text-gray-900 text-sm">Blue wing &amp; gold thread</div>
            <div className="text-sm text-gray-500 mt-1">Peace, trust, liberty — and the light of a new dawn.</div>
          </div>
          <div className="rounded-2xl border border-gray-100 p-5">
            <div className="w-4 h-4 rounded-full bg-amber-400 mb-3"></div>
            <div className="font-semibold text-gray-900 text-sm">Olive branch &amp; spiral tail</div>
            <div className="text-sm text-gray-500 mt-1">Peace flowering into flourishing; the 50th-year homecoming.</div>
          </div>
        </div>

        <p className="not-prose text-center text-xs text-gray-400 italic mt-12">
          "Proclaim liberty throughout the land unto all the inhabitants thereof." — Leviticus 25:10
        </p>
      </div>
      </div>
    </div>
  );
}
